import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import CompanySearch from '../components/CompanySearch'

const CompanySearchPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <CompanySearch />
            </div>
          </main>
    )
}

export default CompanySearchPage